export default [
  {
    title: 'Nosotros',
    route: 'nosotros',
    icon: 'InfoIcon',
  },
]
